'use client'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import {
  PricingRuleModel,
  FactNames,
  isFactGroup,
} from '@marketplace-web/domain/escrow-pricing-data'

type Props = {
  priceRule: PricingRuleModel
}

const TargetedCampaignNote = ({ priceRule }: Props) => {
  const translate = useTranslate('available_discounts')
  const conditionsList = priceRule.conditionTree.all.items

  const hasCampaignNameFact = condition =>
    [FactNames.SellerTargetedCampaignName, FactNames.BuyerTargetedCampaignName].includes(
      condition.fact,
    )

  const isTargetedCampaign = conditionsList.find(condition => {
    if (isFactGroup(condition)) {
      return condition.any.items.find(hasCampaignNameFact)
    }

    return hasCampaignNameFact(condition)
  })

  return isTargetedCampaign ? (
    <div className="available_discounts__price-rule-subtitle">
      {translate('targeted_campaign_note')}
    </div>
  ) : null
}

export default TargetedCampaignNote
